<template>
  <b-button v-b-toggle.sidebar-1 class="burger-button" title="Menu">
    <span class="hidden">Toggle menu</span>
    <span class="burger-bar burger-bar--1"></span>
    <span class="burger-bar burger-bar--2"></span>
    <span class="burger-bar burger-bar--3"></span>
  </b-button>
</template>
<script>
export default {
  name: "burger"
};
</script>
<style>
.hidden {
  visibility: hidden;
}
button {
  cursor: pointer;
}
/* remove blue outline */
button:focus {
  outline: 0;
}
.burger-button {
  position: relative;
  height: 30px;
  width: 32px;
  display: block;
  z-index: 999;
  border: 0;
  border-radius: 0;
  background-color: transparent;
  pointer-events: all;
  transition: transform 0.6s cubic-bezier(0.165, 0.84, 0.44, 1);
}
.burger-button:hover {
  background-color: transparent;
  border: 0;
  border-radius: 0;
  box-shadow: 0 0 0 0;
}
.burger-button:focus {
  background-color: transparent;
  border: 0;
  border-radius: 0;
  box-shadow: 0 0 0 0;
}
.burger-button:active {
  background-color: transparent;
  border: 0;
  border-radius: 0;
  box-shadow: 0 0 0 0;
}

.burger-bar {
  background-color: #d3d3d3;
  position: absolute;
  top: 50%;
  right: 6px;
  left: 6px;
  height: 2px;
  width: auto;
  margin-top: -1px;
  transition: transform 0.6s cubic-bezier(0.165, 0.84, 0.44, 1),
    opacity 0.3s cubic-bezier(0.165, 0.84, 0.44, 1),
    background-color 0.6s cubic-bezier(0.165, 0.84, 0.44, 1);
}
.burger-bar--1 {
  -webkit-transform: translateY(-6px);
  transform: translateY(-6px);
}
.burger-bar--2 {
  transform-origin: 100% 50%;
  transform: scaleX(0.8);
}
.burger-button:hover .burger-bar--2 {
  transform: scaleX(1);
}
.no-touchevents .burger-bar--2:hover {
  transform: scaleX(1);
}
.burger-bar--3 {
  transform: translateY(6px);
}

.burger-button.not-collapsed .burger-button {
  transform: rotate(-180deg);
}
.burger.not-collapsed .burger-bar {
  background-color: #fff;
}
.burger.not-collapsed .burger-bar--1 {
  transform: rotate(45deg);
}
.burger.not-collapsed .burger-bar--2 {
  opacity: 0;
}
.burger.not-collapsed .burger-bar--3 {
  transform: rotate(-45deg);
}
</style>
